import * as React from 'react';
import { DialogRoute } from 'bernie-core';
import { Layer } from 'bernie-view';
import { InfoModal } from 'components/common/info-modal';
import { LocalizedText } from 'bernie-l10n';

export interface DisclaimerDialogProps {
  dialogId: string;
  dialogType: string;
  disclaimerText: string;
  handleClose: () => void;
  innerHTML: boolean;
  layerId: string;
  disclaimerTextId: string;
}

export const DisclaimerDialog: React.FunctionComponent<DisclaimerDialogProps> = ({
  dialogId,
  dialogType,
  disclaimerText,
  handleClose,
  innerHTML,
  layerId,
  disclaimerTextId
}) => (
  <DialogRoute id={dialogId} type={dialogType}>
    <Layer id={layerId} onDismiss={handleClose}>
      <InfoModal closeA11yLabel={<LocalizedText message="close" />} onClose={handleClose}>
        {innerHTML ? (
          <p dangerouslySetInnerHTML={{ __html: disclaimerText }} data-stid={disclaimerTextId} />
        ) : (
          <p data-stid={disclaimerTextId}>{disclaimerText}</p>
        )}
      </InfoModal>
    </Layer>
  </DialogRoute>
);
